import { announcements } from "./announcements";
import { athletes } from "./athletes";
import { beats } from "./beats";
import { chatInvites, chatMessages, chatRooms } from "./chat";
import { club, squads } from "./club";
import { customFields, customValues } from "./custom-fields";
import { directory } from "./directory";
import { documents, folders } from "./documents";
import { events } from "./events";
import { leagues } from "./leagues";
import { clubCourts, clubLocations } from "./locations";
import { memberAudit } from "./member-audit";
import { memberAvailability } from "./member-availability";
import { members } from "./members";
import { membershipTypes } from "./membership-types";
import { newsletters } from "./newsletters";
import { notes } from "./notes";
import { polls } from "./polls";
import { ratings } from "./ratings";
import { reflections } from "./reflections";
import { sams } from "./sams";
import { session } from "./session";
import { skillLevels } from "./skill-levels";
import { tasks } from "./tasks";
import { tournaments } from "./tournaments";
import { training } from "./training";

export const clubApi = {
	announcements,
	athletes,
	beats,
	chatInvites,
	chatMessages,
	chatRooms,
	club,
	clubCourts,
	clubLocations,
	customFields,
	customValues,
	directory,
	documents,
	events,
	folders,
	leagues,
	memberAudit,
	memberAvailability,
	members,
	membershipTypes,
	newsletters,
	notes,
	polls,
	ratings,
	reflections,
	sams,
	session,
	skillLevels,
	squads,
	tasks,
	tournaments,
	training,
};
